import React from 'react';
import { useNavigate } from 'react-router-dom';

import { COOKIE_KEY } from '@/config/constanta';

import { TokenManager } from '@/Router/services/TokenManager';
import PIN_IMAGE from 'Image/PIN/PIN.png';
import { Button, HStack, Typography, VStack } from '@ajaibid/components';
import { FullScreenWrapper, StyledContainer } from './style';

const RenewPin = () => {
  const navigate = useNavigate();
  const handeUpdatePin = () => {
    TokenManager.setCookieData(COOKIE_KEY.pin_need_change, 'true');
    navigate('/create-pin');
  };

  const handleUpdateLater = () => {
    TokenManager.setCookieData(COOKIE_KEY.pin_need_change, 'false');
    navigate('/home');
  };
  return (
    <FullScreenWrapper>
      <StyledContainer>
        <VStack top="24px" bottom="24px" align="center">
          <img src={PIN_IMAGE} alt="" width="320px" />
        </VStack>

        <Typography type="heading" size="sm" textAlign="center">
          Perbarui PIN
        </Typography>
        <Typography type="body" textAlign="center">
          Untuk meningkatkan keamanan kamu dalam menggunakan Ajaib, segera perbarui PIN kamu menjadi
          6 digit angka.
        </Typography>

        <HStack top="24px">
          <Button variant="secondary" size="md" fluid onClick={handleUpdateLater}>
            Nanti Saja
          </Button>
          <div style={{ width: 8 }} />
          <Button variant="primary" size="md" fluid onClick={handeUpdatePin}>
            Perbarui PIN
          </Button>
        </HStack>
      </StyledContainer>
    </FullScreenWrapper>
  );
};

export default RenewPin;
